/**
 * 公共样式类预设
 */
export const StylePreset = {
  /**
   * 卡片容器类集合，容器下的卡片背景颜色有主题色渐变
   */
  CARD_CONTAINER:
    '*:data-[slot=card]:from-primary/5 *:data-[slot=card]:to-card dark:*:data-[slot=card]:bg-card *:data-[slot=card]:bg-gradient-to-t *:data-[slot=card]:shadow-xs',
  /**
   * 侧边栏右侧减去导航栏高度和各种边距后的可用高度，使用该高度配合overflow-y-auto可以固定头部导航栏。
   * --spacing * 12 为导航栏头部高度， --spacing * 3 为 SidebarInset的 margin， --spacing * 4为 main的 padding
   */
  MAIN_CONTENT_HEIGHT:
    'h-[calc(100vh-(var(--spacing)*12)-(var(--spacing)*3*2)-(var(--spacing)*4*2))]',
} as const;
